import React from "react";
import DeliveryContainer from "../../components/Account/Delivery/DeliveryContainer";

type Props = {};

const Delivery = (props: Props) => {
  return (
    <div className="page">
      <DeliveryContainer />
    </div>
  );
};

export default Delivery;
